import React from 'react'
import {Icon} from '@chakra-ui/react'

const HeaderUp = (props) => {
    return (
        <Icon viewBox="0 0 16 16" width="16" height="16" fill="none" {...props} aria-hidden="true">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.46535 10.6861C2.30574 10.4945 2.32191 10.2012 2.50148 10.031L7.85228 4.95764L13.0162 9.83026C13.1961 10 13.213 10.2933 13.0538 10.4852C12.8946 10.6772 12.6197 10.6951 12.4398 10.5253L7.85367 6.19794L3.07947 10.7246C2.89991 10.8948 2.62496 10.8776 2.46535 10.6861Z"
                stroke="#0C2340"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default HeaderUp
